import Client from "./_client";

export const createCodeChallengeAttempt = async (data) => {
  let url = "/codeChallengeAttempt";

  const result = await new Client({
    path: url,
    payload: data
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to create attempt. Please try again."
    );
  }

  return result?.data;
};

export const getRecentCodeChallengeAttempts = async (filters) => {
  let url = "/codeChallengeAttempt/recent?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get attempts. Please try again."
    );
  }
  return result?.data;
}

export const getCodeChallengeAttempts = async (filters) => {
  let url = "/codeChallengeAttempt?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get attempts. Please try again."
    );
  }
  return result?.data;
}

export const getCodeChallengeAttemptById = async (id) => {
  let url = "/codeChallengeAttempt/" + id;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get attempt. Please try again."
    );
  }
  return result?.data;
}
export const generate4CFeedback = async (id) => {
  let url = `/codeChallengeAttempt/${id}/generate-feedback`;

  const result = await new Client({
    path: url,
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to generate feedback. Please try again."
    );
  }

  return result?.data;
};

export const get4cFeedbackByToken = async (accessToken) => {
  let url = `/codeChallengeAttempt/public/token?at=${accessToken}`;
  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get feedback. Please try again."
    );
  }

  return result?.data;
};
